export default __webpack_public_path__ + "static/media/IMG_1989.5d9b8fbe.JPG";